export default {
    title: "Artikelen niet geleverd",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Bedankt",
        message: "Dank u voor uw reactie."
    },
    message: "U heeft aangegeven dat u uw artikel niet heeft ontvangen, terwijl de koerier het wel als bezorgd heeft gemarkeerd.",
    cta: "Volg deze stappen om ons te helpen het probleem op te lossen:",
    items: {
        1: {
            message: "Klik op de trackinglink(s):"
        },
        2: {
            message: "Controleer de bezorgstatus. Controleer op:",
            items: {
                1: "Wie heeft voor het pakket getekend?",
                2: "Als het bericht naar de afzender is teruggestuurd",
                3: "Als het pakket klaar ligt om opgehaald te worden"
            }
        },
        3: {
            message: "Controleer of er een bezorgbericht is waarin staat waar het artikel mogelijk is achtergelaten."
        },
        4: {
            message: "Vraag aan buren, familieleden en vrienden wie het pakket heeft meegenomen."
        }
    },
    question: "Heeft dit geholpen om je vraag over de bezorging te beantwoorden? Heb je het artikel nu of weet je wie het heeft? Reageer hieronder.",
    product: {
        name: "Artikelnaam",
        quantity: "Hoeveelheid",
        tracking: "Volgen",
    },
    buttons: {
        yes: "Ja",
        no: "Nee",
        saving: "Besparing"
    }
}